import { render } from "./IBoard.vue?vue&type=template&id=c0c8ef5c"
import script from "./IBoard.vue?vue&type=script&lang=js"
export * from "./IBoard.vue?vue&type=script&lang=js"

import "./IBoard.vue?vue&type=style&index=0&id=c0c8ef5c&lang=scss"
script.render = render

export default script